import { Component, OnInit, Input, Output, EventEmitter,
        OnChanges, SimpleChanges } from '@angular/core';
import {Film} from 'models/film';
import { SwapiService, Request } from '../swapi.service';
import { SelectedItem } from 'models/selectedItem';

@Component({
  selector: 'app-list-view',
  templateUrl: './list-view.component.html',
  styleUrls: ['./list-view.component.css']
})
export class ListViewComponent implements OnInit, OnChanges {
  
  @Input() title: string;
  @Input() request : Request;
  isSearching : boolean = true;
  selectedItem : SelectedItem;

  hasPrevPage : boolean;
  hasNextPage : boolean;

  @Output() select: EventEmitter<any> = new EventEmitter<any>();
  constructor(private swapiService : SwapiService) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updatePageBools();
  }

  selectItem(selitem:any){
    this.selectedItem = {item:selitem,
                        type:this.request.type};
    this.select.emit(this.selectedItem);
  }

  previousPage(){
    if (this.request.previous != null)
      this.swapiService.getData(this.request.previous, this.request.type).then(data => {
        this.request = data;
        this.updatePageBools();
      });
    
  }

  nextPage(){
    if (this.request.next != null)
      this.swapiService.getData(this.request.next, this.request.type).then(data => {
        this.request = data;
        this.updatePageBools();
      });
      
  }

  updatePageBools(){
    this.hasNextPage = this.request.next != null;
    this.hasPrevPage = this.request.previous != null;
  }


}



// WEBPACK FOOTER //
// ./src/app/list-view/list-view.component.ts